import React from 'react';

const IntegrationTile = ({
  appName,
  appLogo = () => {},
  description,
  isSynced,
  onSyncToggle,
  onLearnMore,
  showSync = true,
  primaryActionLabel = 'Sync',
}) => {
  return (
    <div className="integration-tile-container">
      <div className="integration-tile-header">
        {appLogo()}
        <h3>{appName}</h3>
      </div>
      <p className="integration-tile-description">{description}</p>
      <div className="integration-tile-actions">
        {showSync ? (
          <button
            className={`integration-tile-sync-button ${isSynced ? 'unsync' : 'sync'}`}
            onClick={onSyncToggle}
          >
            {isSynced ? 'Unsync' : 'Sync'}
          </button>
        ) : (
          <button className="integration-tile-sync-button sync" onClick={onSyncToggle}>
            {primaryActionLabel}
          </button>
        )}
        <button className="integration-tile-learn-more-button" onClick={onLearnMore}>
          Learn More
        </button>
      </div>
    </div>
  );
};

export default IntegrationTile;
